import { apiRequest } from './apiClient';

export const fetchApPanelOzet = async () => {
  return apiRequest('/api/admin/panel-ozet', { method: 'GET', skipCsrf: true });
};
